import makeStyles from '@material-ui/styles/makeStyles'

import theme from '../../services/theme-service'

export const useStyles = makeStyles({
  containerTitle: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
  },
  containerTitles: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
  },
  boxTitle: {
    maxWidth: 1320,
    minHeight: 276,
    height: '100%',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(640)]: {
      minHeight: 215,
      gap: 24,
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(32),
    fontWeight: 700,
    textTransform: 'uppercase',
    [theme.breakpoints.down(640)]: {
      fontSize: theme.typography.pxToRem(24),
    },
    '&:first-of-type': {
      color: '#fff',
    },
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(20),
    color: '#fff',
    fontWeight: 500,
    textTransform: 'none',
    [theme.breakpoints.down(640)]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  iconTitle: {
    width: 70,
    height: 70,
    color: '#fff',
    [theme.breakpoints.down(640)]: {
      width: 50,
      height: 40,
    },
  },
  containerMain: {
    maxWidth: 1320,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    margin: '120px auto 0 auto',
    paddingBottom: '116px',
    paddingLeft: '10px',
  },
  list: {
    '& > li': {
      padding: '5px',
    },
  },
  itemTitle: {
    fontSize: theme.typography.pxToRem(18),
    color: '#1F2937',
    fontWeight: 600,
    display: 'block',
  },
})
